// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextRenderer__container-b9d5df {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  display: inline;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./src/components/TextRenderer/TextRenderer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,yBAAA;EACA,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  display: inline;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TextRenderer__container-b9d5df`
};
module.exports = ___CSS_LOADER_EXPORT___;
